import { Box } from '@mui/material'
import UserChatBubbleAddReactionButton from './UserChatBubbleAddReactionButton'
import UserChatBubbleReactionPill from './UserChatBubbleReactionPill'
import styles from './index.module.scss'

export default function UserChatBubbleReactionsBar({
  reactions,
  bubbleAlign,
  onReaction,
  reactionPickerAnchorEl,
  setReactionPickerAnchorEl,
  setMoreMenuAnchor,
}) {
  if (reactions.length === 0) return null

  const reactionsBarClassName =
    bubbleAlign === 'start'
      ? `${styles.reactionsBar} ${styles.reactionsBarStart}`
      : styles.reactionsBar

  const handleReaction = (emoji) => {
    onReaction?.(emoji)
    setReactionPickerAnchorEl(null)
  }

  return (
    <Box className={reactionsBarClassName} role="group" aria-label="Message reactions">
      {reactions.map(({ emoji, count, bySelf }) => (
        <UserChatBubbleReactionPill
          key={emoji}
          emoji={emoji}
          count={count}
          bySelf={bySelf}
          onSelect={handleReaction}
        />
      ))}
      {onReaction ? (
        <UserChatBubbleAddReactionButton
          reactionPickerAnchorEl={reactionPickerAnchorEl}
          setReactionPickerAnchorEl={setReactionPickerAnchorEl}
          setMoreMenuAnchor={setMoreMenuAnchor}
        />
      ) : null}
    </Box>
  )
}
